<div class="process-configuration">
  <ion-list lines="full" mode="ios">
    <ion-item *ngIf="selfEvaluationVersions && selfEvaluationVersions.length > 0">
      <ion-label position="stacked"> {{ 'manageVersion.importSelfEvaluation' | translate }}</ion-label>
      <ion-select (ionChange)="selfEvaluationVersionChanged($event.target.value)">
        <ion-select-option *ngFor="let version of selfEvaluationVersions" [value]="version.id">{{
          version.versionName }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</div>

<ng-container *ngIf="version?.type === ProcessType.ThreeSixtyEvaluation && userAttributesOnProcessAllowedFlag">
  <ion-grid class="user-attributes-allowed">
    <ion-row>
      <ion-col>{{ 'generic.attributeType' | translate }}</ion-col>
      <ion-col>
        {{ 'generic.attributeName' | translate }}
        <div class="user-attribute-settings">
          <a (click)="manageProcessAttributes()">
            <ion-icon class="bp-setting" name="settingsCog"></ion-icon>
            {{ 'generic.configurations' | translate }}
          </a>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let attribute of version.userAttributesItemAllowed">
      <ion-col>{{ attribute.typeName }}</ion-col>
      <ion-col>{{ attribute.name }}</ion-col>
    </ion-row>
  </ion-grid>
</ng-container>

<br />

<div class="groups-selector" *ngIf="managerQuestionGroupsAvailable()">
  <!-- <div><ion-button (click)="selectMainQuestionGroups()">Manager</ion-button></div>
            <div><ion-button (click)="selectManagerQuestionGroups()">Manager</ion-button></div> -->
  <span (click)="selectMainQuestionGroups.emit()" [ngClass]="{ 'selected': !managerQuestionGroupsSelected }">{{
    'manageVersion.mainQuestionGroups' | translate }}
  </span>
  <span class="divider">|</span>
  <span (click)="selectManagerQuestionGroups.emit()" [ngClass]="{ 'selected': managerQuestionGroupsSelected }">{{
    'manageVersion.managerQuestionGroups' | translate }}
  </span>
</div>